import {ChangeDetectionStrategy, Component} from '@angular/core';
import {BiolinkEditorService} from '../../biolink-editor.service';

@Component({
    selector: 'biolink-editor-fonts',
    templateUrl: './biolink-editor-fonts.component.html',
    styleUrls: ['./biolink-editor-fonts.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BiolinkEditorFontsComponent {
    constructor(public editor: BiolinkEditorService) {}
}
